// JsFromRoutes CacheKey eee724bfe465489296a46d8dc7d13782
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  delete: /* #__PURE__ */ definePathHelper('get', '/income/:public_id/delete'),
  index: /* #__PURE__ */ definePathHelper('get', '/income'),
  create: /* #__PURE__ */ definePathHelper('post', '/income'),
  new: /* #__PURE__ */ definePathHelper('get', '/income/new'),
  edit: /* #__PURE__ */ definePathHelper('get', '/income/:public_id/edit'),
  update: /* #__PURE__ */ definePathHelper('patch', '/income/:public_id'),
  destroy: /* #__PURE__ */ definePathHelper('delete', '/income/:public_id'),
}
